import './AFAD.scss';
import {PageManager} from '@mvps-genesis/bootstrap';
import {InputValueCopyTo} from 'extensions/input-value-copy-to';

export default class AFAD extends PageManager {

	constructor (pageContext) {

		super(pageContext);

		new InputValueCopyTo();

	}

}
